import styled from 'styled-components';

const NavigationContentList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 175px;
  margin-top: 10px;
`;

export default NavigationContentList;
